var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8285 5.17163C12.3906 6.73373 12.3906 9.26639 10.8285 10.8285M5.17161 10.8285C3.60952 9.26636 3.60952 6.7337 5.17161 5.17161M3.286 12.7141C0.6825 10.1106 0.6825 5.88951 3.286 3.28601M12.7141 3.28604C15.3176 5.88954 15.3176 10.1106 12.7141 12.7141M9.33337 8.00006C9.33337 8.73644 8.73642 9.33339 8.00004 9.33339C7.26366 9.33339 6.66671 8.73644 6.66671 8.00006C6.66671 7.26368 7.26366 6.66672 8.00004 6.66672C8.73642 6.66672 9.33337 7.26368 9.33337 8.00006Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveMap);
export default __webpack_public_path__ + "static/media/liveMap.7312ea41fdf4ec4386897ce9e59427d9.svg";
export { ForwardRef as ReactComponent };